import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { STATES } from "../../util/constant";
import API from "../../util/api";

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
`;

const Header = styled.div`
  background: ${(p) => p.colors.buttonBackground};
  color: ${(p) => p.colors.buttonText};
  padding: 12px 16px;
  font-size: 18px;
  font-weight: bold;
`;

const Body = styled.div`
  padding: 16px;
  font-size: 14px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  label {
    width: 100px;
    font-size: 13px;
  }
  select {
    flex: 1;
    padding: 6px;
    font-size: 13px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
`;

const Footer = styled.div`
  padding: 12px 16px;
  text-align: right;
  border-top: 1px solid #eee;

  button {
    margin-left: 8px;
    padding: 6px 14px;
    font-size: 13px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .submit {
    background: ${(p) => p.colors.buttonBackground};
    color: #fff;
  }
  .close {
    background: transparent;
    color: ${(p) => p.colors.buttonBackground};
  }
`;

export default function SchoolIDSearchPopup({ colors, onClose }) {
  // derive state list from your constant
  const stateOptions = Object.entries(STATES).map(([name, abbr]) => ({
    name, abbr
  }));

  const [cities, setCities]     = useState([]);
  const [schools, setSchools]   = useState([]);

  const [selState, setSelState]   = useState("");
  const [selCity, setSelCity]     = useState("");
  const [selSchool, setSelSchool] = useState("");

  const [resultId, setResultId] = useState(null);

  // when state changes, fetch cities
  useEffect(() => {
    setCities([]);
    setSelCity("");
    setSchools([]);
    setSelSchool("");
    if (selState) {
               API.getCityByState({ state: selState })
       .then((resp) => {
         // resp.cities is an object: { ABBEVILLE: "ABBEVILLE", … }
         setCities(Object.values(resp.cities || {}));
       })
       .catch(() => setCities([]));
    }
  }, [selState]);

  useEffect(() => {
    setSchools([]);
    setSelSchool("");
    if (selCity) {
          API.getSchoolsByCity({ state: selState, city: selCity })
       .then((resp) => {
         // assuming resp.schools comes back in the same shape
         setSchools(Object.values(resp.schools || {}));
       })
       .catch(() => setSchools([]));
    }
  }, [selCity, selState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resp = await API.getSchoolId({
      state: selState,
      city: selCity,
      school: selSchool,
    });
    setResultId(resp.school_id);
  };

  return (
    <Overlay>
      <Modal>
        <Header colors={colors}>Find your School ID</Header>
        <Body>
          <form onSubmit={handleSubmit}>
            <Row>
              <label htmlFor="field-states">States</label>
              <select
                id="field-states"
                value={selState}
                onChange={(e) => setSelState(e.target.value)}
              >
                <option value="">Select State</option>
                {stateOptions?.map(({ name, abbr }) => (
                  <option key={abbr} value={abbr}>
                    {name}
                  </option>
                ))}
              </select>
            </Row>

            <Row>
              <label htmlFor="field-cities">Cities</label>
              <select
                id="field-cities"
                value={selCity}
                disabled={!selState}
                onChange={(e) => setSelCity(e.target.value)}
              >
                <option value="">Select City</option>
                {cities?.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </Row>

            <Row>
              <label htmlFor="field-schools">Schools</label>
              <select
                id="field-schools"
                value={selSchool}
                disabled={!selCity}
                onChange={(e) => setSelSchool(e.target.value)}
              >
                <option value="">Select School</option>
                {schools?.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </Row>

            {resultId && (
              <div style={{
                margin: "16px 0",
                fontWeight: "bold",
                fontSize: "15px",
                textAlign: "center"
              }}>
                Your School ID is {resultId}
              </div>
            )}

            <Footer colors={colors}>
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                Close
              </button>
              <button
                type="submit"
                className="submit"
                disabled={!selState || !selCity || !selSchool}
              >
                Submit
              </button>
            </Footer>
          </form>
        </Body>
      </Modal>
    </Overlay>
  );
}
